module.exports = __webpack_public_path__ + "static/Hero-Banner-Retail-rapidshop-39715b31b1d49785f26b9f2e3fce8628.png";